export default __webpack_public_path__ + "static/media/Group 23.dfe33676.png";